module.exports = __webpack_public_path__ + "static/media/bcv-icon.b1d01de9.png";